<template>
    <!-- 联系我们 -->
    <div class="contact">
        <img width="100%" src="@/assets/img/contact_banner.png" alt="">
        <div class="bottom">
            <div class="title">{{ $t('contact.title') }}</div>
            <div class="info">
                <div class="detail">
                    <div>{{ $t('contact.email') }}</div>
                    <div>{{ $t('contact.wechat') }}</div>
                    <div>{{ $t('contact.redbook') }}</div>
                    <div>{{ $t('contact.tiktok') }}</div>
                    <div>{{ $t('contact.phone') }}</div>
                    <div>{{ $t('contact.address') }}</div>
                </div>
                <img width="460" src="@/assets/img/member.png" alt="">
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'Contact',
}
</script>
  
<style scoped>
.bottom {
    margin: 75px auto 0;
    width: 1000px;
}

.info {
    display: flex;

}

.detail {
    flex: 1;
    font-size: 28px;
}

.detail>div {
    margin-bottom: 10px;
}

.title {
    margin-bottom: 30px;
    font-size: 36px;
}
</style>
  